import '../vendor/slick';
import '../vendor/jquery.transit';
import '../vendor/jquery.mCustomScrollbar';

import '../scss/index.scss';

import contentBrowser from './components/content-browser';
import cookie         from "../../base/js/components/cookie/cookie";
import ctaMedia       from './components/cta-media';
import emForm         from '../../base/js/components/em-form';
import lightBox       from './components/lightbox';
import modal          from './components/modal';
import navigation     from './components/navigation';
import videoBox       from './components/video-box';
import scrollBar      from './components/scroll-bar';

$(() => {
  contentBrowser();
  ctaMedia();
  cookie();
  emForm();
  lightBox();
  modal();
  navigation();
  videoBox();
  scrollBar();
});
